/**
 * La chaîne de requête d'un appel de liste — **une seule fabrique**, partagée par toutes les
 * familles d'appels.
 *
 * ⚠️ **Un paramètre non demandé n'est pas envoyé vide.** `?status=` ou `?limit=` laisserait croire
 * à une demande précise là où le serveur retombe sur son défaut, et une URL de journal mentirait
 * sur ce qui a été demandé. La chaîne vide suit la même règle : c'est le défaut de la recherche,
 * donc « pas de recherche », donc rien à écrire.
 *
 * Rend `''` — pas `'?'` — quand rien n'est demandé : `/inquiries?` et `/inquiries` sont la même
 * ressource, la seconde se lit.
 */
export function queryString(request) {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(request)) {
        if (value === undefined || value === '')
            continue;
        params.set(key, String(value));
    }
    const query = params.toString();
    return query === '' ? '' : `?${query}`;
}
//# sourceMappingURL=query-string.js.map